export const ZOOM_MENU = {
  RATE: 0.25,
  MAX: 2.5,
  MIN: 1.0,
  OPTIONS: [
    {value: 2.5, label: '250%'},
    {value: 2.0, label: '200%'},
    {value: 1.5, label: '150%'},
    {value: 1.25, label: '125%'},
    {value: 1.0, label: '100%'},
  ],
};
